<template>
  <main>
    <div class="d-table margin-t-large bg-white mx-auto fit-width d-table mt-3 pb-3">
      <h2 class="font-heading-1 darkgrey font-family-concended font-all-upper">Coming Soon</h2>
      <div class="underlined darkgreen"></div>
    </div>
    <p
      class="font-paragraph-1 d-table mx-auto col-md-8 col-sm-12 paragraph-margins text-center"
    >Check back on November 6th to continue your learning with Starbucks Coffee Academy videos, guided audio tastings and brew guides.</p>
    <div class="d-table margin-t-large bg-white mx-auto fit-width d-table mx-auto">
      <h2 class="font-heading-1 darkgrey font-family-concended font-all-upper">ADDITIONAL RESOURCES</h2>
      <div class="underlined darkgreen"></div>
    </div>
    <div class="container margin-t-large  pt-0 resource-accordian">
      <div class="accordion">
        <a href="JavaScript:void(0)" class="accordion-item d-block font-black " v-for="(resourse,i) in resourses" >
          <header class="res-accordion-header accordion-header" role="button" :aria-controls="`res-accordian-${i}`" aria-expanded="false">
            <h2>{{resourse.heading}}</h2>
          </header>
          <main :id="`res-accordian-${i}`" class="res-accordion-body accordion-body" role="tabpanel">
            <div class="border-top-solid"></div>
            <ul>
                <li v-for="content in resourse.content" v-html="content"></li>
            </ul>
          </main>
        </a>
      </div>
    </div>
    <!-- <div class="container margin-t-large  pt-0 resource-accordian">
      <div class="accordion">
        <a href="JavaScript:void(0)" class="accordion-item d-block font-black " v-for="(partners,i) in partners" >
          <header class="res-accordion-header accordion-header" role="button" :aria-controls="`res-accordian-${i}`" aria-expanded="false">
            <h2>{{partners.heading}}</h2>
          </header>
          <main :id="`res-accordian-${i}`" class="res-accordion-body accordion-body" role="tabpanel">
            <div class="border-top-solid"></div>
            <ul>
                <li v-for="content in partners.content" v-html="content"></li>
            </ul>
          </main>
        </a>
      </div>
    </div> -->
  </main>
</template>

<script>
  import resourses from "../assets/documents/resourses.json"
  import partners from "../assets/documents/partners.json"
  export default {
    data(){
      return{
        resourses : resourses.data,
        partners : partners.data
      }
    },
    mounted() {
      const accordionItem = document.querySelectorAll(".accordion-item");
      const onClickAccordionHeader = e => {
        if (e.currentTarget.parentNode.classList.contains("active")) {
          e.currentTarget.parentNode.classList.remove("active");
          e.currentTarget.setAttribute("aria-expanded" , "false")
        } else {
          Array.prototype.forEach.call(accordionItem, e => {
            e.classList.remove("active");
          });
          e.currentTarget.parentNode.classList.add("active");
          if(e.currentTarget.parentNode.getAttribute("aria-expanded") === 'true'){
            e.currentTarget.setAttribute("aria-expanded" , "false")
          }else{
            e.currentTarget.setAttribute("aria-expanded" , "true")
          }
        }
      };

      const init = () => {
        Array.prototype.forEach.call(accordionItem, e => {
          e.querySelector(".accordion-header").addEventListener(
            "click",
            onClickAccordionHeader,
            false
          );
        });
      };

      document.addEventListener("DOMContentLoaded", init);
    }
  };
</script>
<style>
    
    .accordion-body ul li
    {
        display: block;
        margin: 1px 3px 24px 10px;
        text-indent: -23px;
        font-size: 16px;
        line-height: 24px;
    }
    .accordion-body ul li:before 
    {
        content: "";
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 13px;
        background-color: #00704A;
    }
    .accordion-body2 ul li:before 
    {
        content: "";
        display: inline-block;
        width: 5px;
        height: 5px;
        margin-right: 18px;
        background-color: #00704A;
        border-radius: 2px; 
    }
</style>
